<script>
  export let text;
</script>

{#if text.forEach}
  {#each text as { type, value }}
    {#if type == 'headline'}
      <h2>
        {@html value}
      </h2>
    {:else}
      <p>
        {@html value}
      </p>
    {/if}
  {/each}
{:else}
  <p>
    {@html text}
  </p>
{/if}

<style>
  p {
    position: relative;
    z-index: 10;
  }
  :global(strong) {
    font-weight: 700;
  }
  :global(em) {
    font-style: italic;
  }
</style>
